import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Observable, EMPTY } from 'rxjs';
import { BaseWithHttpService } from './baseWithHttp.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService extends BaseWithHttpService {
  apiUrl: string = '';
  apiKey: string = '';
  workbenchapiUrl: string = '';

  constructor(http: HttpClient, private https: HttpClient, @Inject(OKTA_AUTH) auth: OktaAuth, @Inject('CONFIG_SETTINGS') config: any) {
    super(http, auth);
    const configSettings = config['general'];
    this.apiUrl = configSettings['adminApiUrl'];
    this.apiKey = configSettings['apiKey'];
    //-------------
    const workbenchConfigSettings = config['general'];
    this.workbenchapiUrl = workbenchConfigSettings['adminApiUrl'];
    //------------------
  }
  private getAllItems<T>(url: string): Observable<T[]> {
    const token = this.getToken();
    //const url = this.apiUrl + this.getEndpoint;
    if (token != undefined) {
      return this.https.get<T[]>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }


  //-------------------------
  getLatestProjectDeliverables(): Promise<any> {
    const url = `${this.workbenchapiUrl}SalesAndDeliveryHub/latestprojectdeliverables`;
    return this.getItems<any>(url);
  }
  //getVideoLnks(): Promise<any> {
  //  const url = `${this.workbenchapiUrl}Common`;
  //  return this.getItems<any>(url);
  //}
  loadTeams(): Promise<any> {
    const url = `${this.workbenchapiUrl}Common/loadteams`;
    return this.getItems<any>(url);
  }
  getTeamViewFolder1(encodedPackageName: String): Promise<any> {
    const url = `${this.workbenchapiUrl}Common/getteamfolder/${encodedPackageName}`;
    return this.getItems<any>(url);

  }
  getTeamFolders(teamId: String): Promise<any> {
    const url = `${this.workbenchapiUrl}Common/GetTeamFolders/${teamId}`;
    return this.getItems<any>(url);

  }
  getremotefoldersforteam(id?: string, teamId?: String): Promise<any> {
    const url = `${this.workbenchapiUrl}Common/getremotefoldersforteam/${id}/${teamId}`;
    return this.getItems<any>(url);

  }
  getremotefoldersforteamById(id?: String, teamId?: String): any {
    const url = `${this.workbenchapiUrl}Common/getremotefoldersforteam/${id}/${teamId}`;
    return this.getItems<any>(url);

  }
  uploadsharepointfiles(encodedPackageName: any, teamId: any, folderId: any): Promise<any> {
    const url = `${this.workbenchapiUrl}Common/uploadsharepointfiles/{encodedPackageName}/{teamId}/{folderId}`;
    return this.postAny(undefined, url);

  }
}


export interface ILatestProjectDeliverable {
  id: string
  title: string;
  url: string;
  modifiedDate: Date;
  author: string;
}
